import { DataEditorProps, Row, Rows, ValueViewerProps } from 'common/types/scalarSpreadsheet';
import { SelectValueViewer } from 'components';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX } from 'pages/FundInvestments/common/constants';
import { FundInvestmentSummaryCellData } from 'pages/FundInvestments/hooks/useFundInvestmentSummarySheet';
import { getFundName } from 'pages/FundInvestments/utils';
import { generateColumnKey, getArrayValue, getNumberValue, getObjectValue, getStringValue } from 'utilities';
import { CreateFundRowsParams } from './createFundRows.types';

const createFundRows = (params: CreateFundRowsParams): Rows => {
  const { forceReadOnly, fundInvestmentDetails, fundOptions } = params;

  const fundRows = getArrayValue(
    fundInvestmentDetails?.map(currentFundInvestment => {
      const { id, fund: fundId, uuid } = getObjectValue(currentFundInvestment);

      const columnKey = generateColumnKey({
        id: getNumberValue(id),
        name: getStringValue(uuid),
        prefix: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX,
      });

      return {
        alias: columnKey,
        dataEditor: (props: DataEditorProps) => (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore: GridSelect is not typed
          <GridSelect {...props} options={fundOptions} />
        ),
        data: {
          fundInvestmentId: id,
          fundInvestmentUuid: uuid,
          name: getFundName({ fundId, fundOptions }), // Display the fund name on confirm delete dialog
        } as FundInvestmentSummaryCellData,
        dbType: 'number', // Fund ID
        dropdown: true,
        gridType: 'number',
        isDeletableRow: true,
        isEditableTitleCell: true,
        isRequired: true,
        readOnly: forceReadOnly,
        titleClassName: 'text-left',
        useScalarSpreadsheetCell: true,
        value: fundId,
        valueViewer: (props: ValueViewerProps) => (
          <SelectValueViewer {...props} options={fundOptions} readOnly={forceReadOnly} />
        ),
      } as Row;
    })
  );

  return fundRows;
};

export default createFundRows;
